import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/approval.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleReviewRequestApprovedAndMergedEvent, ActivityEventTrackMode } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleReviewRequestApprovedAndMergedEvent
}

const ArticleReviewRequestApprovedAndMerged = ({ event, ...props }: Props) => {
  const { user, article, data } = event
  const { base_branch, branch, message } = data

  const isBaseBranch = base_branch.key === article.key

  const content = isBaseBranch ? (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> approved and merged the changes
      from this linked copy:{' '}
      <Link to={branch.url} onClick={stopPropagation}>
        {branch.title}
      </Link>
    </>
  ) : (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> approved this linked copy and
      merged the changes
    </>
  )

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      trackMode={ActivityEventTrackMode.Merge}
      message={message}
      content={content}
    />
  )
}

export { ArticleReviewRequestApprovedAndMerged }
